var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1118_20606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98847 0.501909C6.98847 0.501909 11.1069 0.317784 13.2905 4.44196H6.63803C6.63803 4.44196 5.38258 4.40164 4.31014 5.91898C4.00208 6.55585 3.67094 7.21189 4.04254 8.50479C3.50723 7.60127 1.20056 3.59989 1.20056 3.59989C1.20056 3.59989 2.82756 0.664951 6.98841 0.501909H6.98847Z",
    fill: "#EF3F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0767 10.9716C13.0767 10.9716 11.1763 14.6181 6.50134 14.4378C7.07898 13.4423 9.8285 8.69849 9.8285 8.69849C9.8285 8.69849 10.4928 7.6358 9.70913 5.9516C9.31052 5.36655 8.90424 4.75463 7.59499 4.42849C8.64823 4.41896 13.279 4.42849 13.279 4.42849C13.279 4.42849 15.0137 7.30013 13.0767 10.9716Z",
    fill: "#FCD900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.929074 11.0004C0.929074 11.0004 -1.29098 7.53798 1.20439 3.59412C1.78011 4.5897 4.52963 9.33346 4.52963 9.33346C4.52963 9.33346 5.12268 10.4384 6.97687 10.6033C7.68356 10.5515 8.41905 10.5074 9.35872 9.54254C8.84069 10.4556 6.51663 14.4455 6.51663 14.4455C6.51663 14.4455 3.15099 14.5069 0.929019 11.0004H0.929074Z",
    fill: "#61BC5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49939 14.4724L7.43512 10.5823C7.43512 10.5823 8.46332 10.5016 9.32595 9.55981C8.79064 10.4979 6.49939 14.4724 6.49939 14.4724Z",
    fill: "#5AB055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85388 7.53029C3.85388 5.81542 5.24986 4.42468 6.97117 4.42468C8.69249 4.42468 10.0885 5.81542 10.0885 7.53029C10.0885 9.2452 8.69249 10.6359 6.97117 10.6359C5.24986 10.634 3.85388 9.2452 3.85388 7.53029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37561 7.53027C4.37561 6.10314 5.53668 4.94452 6.97115 4.94452C8.40365 4.94452 9.56663 6.10124 9.56663 7.53027C9.56663 8.95745 8.40562 10.1161 6.97115 10.1161C5.53859 10.1161 4.37561 8.95745 4.37561 7.53027Z",
    fill: "url(#paint0_linear_1118_20606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2769 4.43048L9.42408 5.55648C9.42408 5.55648 8.84261 4.70667 7.59302 4.43048C8.67704 4.42471 13.2769 4.43048 13.2769 4.43048Z",
    fill: "#EACA05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96747 8.36279C3.42636 7.42861 1.20056 3.59985 1.20056 3.59985L4.05408 6.41195C4.05408 6.41195 3.76138 7.01237 3.87118 7.87171L3.96741 8.36279H3.96747Z",
    fill: "#DF3A32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1118_20606",
    x1: 6.97102,
    y1: 4.98103,
    x2: 6.97102,
    y2: 9.96041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1072BA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1118_20606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeWeb);
export default __webpack_public_path__ + "static/media/chrome_web.580cd28a45ff863a993882c22fd66180.svg";
export { ForwardRef as ReactComponent };